import { useCallback } from "react";
import { ReactComponent as MinusIcon } from "../../assets/minus.svg";
import { ReactComponent as PlusIcon } from "../../assets/plus.svg";
// styles
import styles from "../../styles/Select.module.css";

interface CounterProps {
  value: number;
  onChange: (value: number) => void;
  label: string;
}

const Counter: React.FC<CounterProps> = ({
  value,
  onChange,
  label,
}) => {
  const onAdd = useCallback(() => {
    if (value < 100) {
      onChange(value + 1);
    }
  }, [onChange, value]);

  const onReduce = useCallback(() => {
    if (value > 1) {
      onChange(value - 1);
    }
  }, [onChange, value]);

  return (
    <div className={styles.customSelect}>
      {label &&
        <label className={styles.inputLabel}>
          {label}
        </label>
      }
      <div className="selected-text counter" style={{ background: 'none' }}>
        <div style={{ padding: '0.8rem 0.8rem 0.8rem 1rem' }}>{value}</div>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <div onClick={onReduce} style={{ display: 'flex', padding: '1rem' }}>
            <MinusIcon />
          </div>
          <div onClick={onAdd} style={{ display: 'flex', padding: '1rem' }}>
            <PlusIcon />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Counter;
